import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function CorporateTrainingAndProfessionalDevelopment() {
  return (
    <div className="font-sans text-gray-800">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Trainings', 'Corporate Training & Professional Development']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Trainings
        </h2>

        <div className="flex items-center gap-2 mb-4 mt-12">
          <span className="w-4 h-4 rounded-full bg-sky-300  flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Corporate Training & Professional Development
          </h3>
        </div>

        <p className="mb-4 text-[#05326D] font-bold">
          Empowering People, Strengthening Culture, Elevating Performance
        </p>

        <p className="mb-6 text-[#05326D]">
          At FDAC Consultancy, we believe that people are the most valuable asset of any organization. In today’s globally connected and rapidly evolving business landscape, investing in human capital is no longer optional—it’s essential. Our Corporate Training Programs are designed to build resilient, culturally aware, and high-performing teams that thrive in dynamic environments.
        </p>

        <p className="mb-6 text-[#05326D]">
          Over the past two decades, the training function has evolved from a support arm under HR to a strategic driver of organizational growth. As businesses navigate cross-cultural teams, digital transformation, and shifting market demands, the need for continuous learning and skill enhancement has become critical to sustaining productivity, profitability, and brand reputation.
        </p>

        <hr className="border-t border-gray-300 my-8" />

        {/* Why Corporate Training Matters */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Why Corporate Training Matters
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Bridges the gap between current capabilities and future demands</p>
        <p className="ml-2 mt-2 text-[#05326D]">Enhances cultural sensitivity, emotional intelligence, and ethical awareness</p>
        <p className="ml-2 mt-2 text-[#05326D]">Fosters collaboration, adaptability, and leadership across all levels</p>
        <p className="ml-2 mt-2 text-[#05326D]">Drives organizational transformation through empowered individuals</p>
        <p className="ml-2 mt-2 text-[#05326D]">Reinforces values, strengthens team dynamics, and cultivates innovation</p>


        {/* Training Delivery Formats */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Our Training Delivery Formats
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Onsite Workshops</p>
        <p className="ml-2 mt-2 text-[#05326D]">Virtual Training Sessions</p>
        <p className="ml-2 mt-2 text-[#05326D]">City-Based Seminars</p>
        <p className="ml-2 mt-2 text-[#05326D]">Customized Learning Journeys</p>
        <p className="ml-2 mt-2 text-[#05326D]">Post-COVID Remote Engagement Programs</p>


        {/* Training Modules */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Training Modules We Offer
          </span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8 text-sm text-[#05326D]">
          <span>Leadership Skills</span>
          <span>Business Communication</span>
          <span>Email & Business Etiquette</span>
          <span>Telephone Etiquette</span>
          <span>Interview Skills</span>
          <span>Team Building</span>
          <span>Negotiation Skills</span>
          <span>Voice & Accent</span>
          <span>Language Training</span>
          <span>Grooming & Dining Etiquette</span>
          <span>Tele Sales & Outbound Training</span>
          <span>Presentation Skills</span>
          <span>Time Management</span>
          <span>Stress Management</span>
          <span>Conflict Resolution</span>
          <span>Decision Making</span>
          <span>Goal Setting</span>
          <span>Creative Thinking</span>
          <span>Assertiveness</span>
          <span>Listening Skills</span>
          <span>Parenting Workshops</span>
          <span>Customer Service</span>
          <span>Culture Sensitization</span>
          <span>Hospitality Training</span>
          <span>Organizational Behaviour</span>
          <span>Change Management</span>
          <span>Campus to Corporate</span>
          <span>Transactional Analysis</span>
          <span>Coaching & Mentoring</span>
          <span>Facilitation Skills</span>
          <span>SWOT Analysis</span>
          <span>JOHARI Window</span>
          <span>Body Language</span>
          <span>Culture Training</span>
          <span>Train the Trainer</span>
          <span>Empathy & Rapport Building</span>
        </div>

        {/* Our Approach */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Our Approach
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Real-World Relevance: Training sessions are enriched with case studies and practical scenarios</p>
        <p className="ml-2 mt-2 text-[#05326D]">Inclusive & Adaptive: Programs are tailored to suit diverse roles, industries, and learning styles</p>
        <p className="ml-2 mt-2 text-[#05326D]">Continuous Learning Culture: We help organizations build a mindset of growth and agility</p>
        <p className="ml-2 mt-2 text-[#05326D]">Cultural Fitment: We partner with organizations that value people, ethics, and transformation</p>

        <p className="text-[#05326D] mt-4">
          In a world of constant change, training is not just a function—it’s a strategic imperative. Let FDAC help you craft a learning ecosystem that inspires, equips, and transforms your workforce.
        </p>
      </div>
    </div>
  );
}

export default CorporateTrainingAndProfessionalDevelopment;
